export const MIN_QUESTIONS_COUNT = 1
export const MAX_QUESTIONS_COUNT = 100
export const MIN_ANSWERS_COUNT = 2
export const MAX_ANSWERS_COUNT = 50
